import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IndexVersionParams, IndexView, IndexViewComposition, PaginatedV4Response, V4_API_PREFIX } from '../..';
import { QueryParametersService } from '../query-parameters.service';

@Injectable({
  providedIn: 'root',
})
export class IndexVersionsService {
  private readonly http = inject(HttpClient);
  private readonly queryParametersService = inject(QueryParametersService);
  private readonly API_PREFIX = `${V4_API_PREFIX}index-version/`;

  public indexVersions(params: IndexVersionParams = {}): Observable<PaginatedV4Response<IndexView>> {
    return this.http.get<PaginatedV4Response<IndexView>>(this.API_PREFIX, {
      params: this.queryParametersService.prepareParameters(params),
    });
  }

  public composition(index_version_id: string): Observable<PaginatedV4Response<IndexViewComposition>> {
    return this.http.get<PaginatedV4Response<IndexViewComposition>>(`${this.API_PREFIX}${index_version_id}/composition/`);
  }
}
